module.exports = __webpack_public_path__ + "media/images/collection-2-fd7dab912ad1d2fb480839cd912b8223.jpg";